const DocumentCategory = {
  None: 0,
  ThrpyReferral: 1,
  StudentEvaluationDocument: 2,
  AffirmativeLetter: 3,
};

export default DocumentCategory;
